import { render, staticRenderFns } from "./SequencingDrill.vue?vue&type=template&id=5b6454b8&scoped=true"
import script from "./SequencingDrill.vue?vue&type=script&lang=js"
export * from "./SequencingDrill.vue?vue&type=script&lang=js"
import style0 from "./SequencingDrill.vue?vue&type=style&index=0&id=5b6454b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6454b8",
  null
  
)

export default component.exports